import { calculateValue } from "@shared/services/tour/mockedApis/usageExposer/helper.ts";
import { GetPackagesTrafficForPeriodV2Response } from "@shared/services/usageExposer/getPackagesTrafficForPeriod.ts";

import json from "../../json/usageExposer/dashboard/usageExposerGetPackagesTrafficForPeriod.json";

const updateUsage = <T extends GetPackagesTrafficForPeriodV2Response>(
  usageExposerStatisticsV2Response: T,
  updateCallback: (value: number) => number,
): T => {
  usageExposerStatisticsV2Response.packages.forEach((server) => {
    server.trafficBytes = updateCallback(server.trafficBytes);
  });

  return usageExposerStatisticsV2Response;
};

export default async () =>
  updateUsage(JSON.parse(JSON.stringify(await json)), calculateValue);
